import React, { useState } from 'react';
import { Box, Container, Typography, Grid, Paper, TextField, Button } from '@mui/material';
import { HeaderV2, FooterV2 } from '../../components/layout';

const ProfilePageV2 = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => { e.preventDefault(); /* TODO: integrate profile save */ };
  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <HeaderV2 />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>My Profile</Typography>
        <Paper sx={{ p: 3 }} component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField label="Full Name" name="name" fullWidth value={form.name} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField label="Email" name="email" fullWidth value={form.email} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField label="Phone" name="phone" fullWidth value={form.phone} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained">Save Changes</Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <FooterV2 />
    </Box>
  );
};

export default ProfilePageV2;
